import React, { forwardRef } from "react";
import styles from "./numberinput.module.css";

export default forwardRef((props, ref) => (
  <input
    ref={ref}
    type="text"
    inputMode="numeric"
    pattern="[0-9]*"
    maxLength="1"
    value={props.value}
    onChange={props.onChange}
    className={styles.numinput}
    readOnly={props.phone}
  />
));
